<template>
  <div class="center-map-right">
    <div class="panel-title">
      🔌 设备动力环境监测
      <span class="pv-map-side-hint">离线优先</span>
    </div>
    <div class="device-scroll-wrap">
      <div class="device-scroll">
        <div
          v-for="row in doubledRows"
          :key="row._uid"
          class="dev-item"
          @click="onJump(row)"
        >
          <span class="dev-dot" :class="row.dotClass" />
          <span class="dev-sname">{{ row.name }}</span>
          <span class="dev-suffix" v-html="row.suffix" />
        </div>
      </div>
    </div>
    <div class="device-env-footer">
      <span
        >🟢 <span style="color: #00e676">{{ statusCount.online }}</span> 在线</span
      >
      <span
        >🟠 <span style="color: #ffa500">{{ statusCount.warn }}</span> 告警</span
      >
      <span
        >🔴 <span style="color: #ff5252">{{ statusCount.offline }}</span> 离线</span
      >
    </div>
  </div>
</template>

<script>
import { showStationJumpAlert } from "../../common/pv-data";
import { getSiteEnvMonitor } from "@/network/photovoltaic";

function dotClassFromItem(item) {
  const t = (item && item.type) ? String(item.type) : "";
  if (/离线|offline|停运/i.test(t)) return "offline";
  if (/告警|alarm|故障|fault|warn/i.test(t)) return "warn";
  const s =
    typeof item.status === "number"
      ? item.status
      : parseInt(item.status, 10);
  if (!Number.isNaN(s)) {
    if (s === 2 || s === 3) return "offline";
    if (s === 1) return "warn";
    if (s === 0) return "online";
    if (s < 0) return "offline";
  }
  return "online";
}

/** 告警 / 离线 优先升序排序 */
function cmpMonitor(a, b) {
  const ca = dotClassFromItem(a);
  const cb = dotClassFromItem(b);
  const w = { offline: 0, warn: 1, online: 2 };
  const da = w[ca];
  const db = w[cb];
  if (da !== db) return da - db;
  return (a.spaceName || "").localeCompare(b.spaceName || "");
}

export default {
  name: "PvDeviceEnvPanel",
  data() {
    return {
      baseRows: [],
      pollTimer: null,
    };
  },
  computed: {
    doubledRows() {
      const dup = [...this.baseRows, ...this.baseRows];
      return dup.map((r, idx) => ({
        ...r,
        _uid: `${r.key}-${idx}`,
      }));
    },
    statusCount() {
      let online = 0;
      let warn = 0;
      let offline = 0;
      for (let i = 0; i < this.baseRows.length; i++) {
        const dc = this.baseRows[i].dotClass;
        if (dc === "offline") offline++;
        else if (dc === "warn") warn++;
        else online++;
      }
      return { online, warn, offline };
    },
  },
  mounted() {
    this.fetchList();
    this.pollTimer = setInterval(() => this.fetchList(), 45000);
  },
  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  },
  methods: {
    suffixHtml(item, dc) {
      const temp =
        item.avgTemperature != null && !Number.isNaN(Number(item.avgTemperature))
          ? `${Number(item.avgTemperature).toFixed(1)}°C`
          : "--°C";
      const tag = item.type
        ? ` <span style="color:rgba(255,255,255,0.35)">${item.type}</span>`
        : "";
      const icon =
        dc === "offline"
          ? `<span style="color:#ff5252">离线</span>`
          : dc === "warn"
            ? `<span style="color:#ffa500">告警</span>`
            : `<span style="color:#00e676">正常</span>`;
      return `<span style="color:rgba(255,255,255,0.4)">${temp}</span> ${icon}${tag}`;
    },
    mapRows(list) {
      const sorted = (list || []).slice().sort(cmpMonitor);
      return sorted.map((item, i) => {
        const dc = dotClassFromItem(item);
        const name =
          item.spaceName || item.name || `站点${item.spaceId != null ? item.spaceId : i}`;
        return {
          key: `s-${item.spaceId}-${i}`,
          name,
          dotClass: dc,
          suffix: this.suffixHtml(item, dc),
          spaceId: item.spaceId,
        };
      });
    },
    fetchList() {
      getSiteEnvMonitor()
        .then((res) => {
          if (!res || res.code !== 0) return;
          const list = Array.isArray(res.data) ? res.data : [];
          this.baseRows = this.mapRows(list);
        })
        .catch(() => {});
    },
    onJump(row) {
      showStationJumpAlert(row.name);
      this.$emit("jump-station", row.name, row.spaceId);
    },
  },
};
</script>
